<template>
  <div>
    <data-table :service="ClientTokensService"
                :searchable="false"
                :columns="columns"
                :filters="filters"
                :go-to-add-on-click="false"
                :go-to-details-on-row-click="false"
                :entity="entity"
                operations="delete,add,refresh"
                @on-add="createToken"
                ref="table">
      <template v-slot:table-header-left>
        <div v-html="$t('client.tokens.info', {link: multiPosterLink})"></div>
      </template>
      <template slot="name" slot-scope="{row}">
        <editable-grid-cell :value="row.name"
                            placeholder="Name"
                            @change="(val) => updateRowName(val, 'name', row)">
          {{row.name}}
        </editable-grid-cell>
      </template>

      <template v-slot:token="{row}">
        <base-button size="sm"
                     class="mr-1"
                     @click="copy(row.token)"
                     icon outline type="info">
          <i class="fas fa-copy"></i>
        </base-button>
        <span>{{row.token}} </span>&nbsp;
      </template>
      <template v-slot:active="{row}">
        <base-switch :value="Boolean(row.active)"
                     @input="val => updateRowStatus(row, val)"/>
      </template>
      <template v-slot:payment_type="{row}">
        <simple-payment-type-select :value="row.payment_type_id" @change="onPaymentTypeChange($event, row)"></simple-payment-type-select>
      </template>
      <template v-slot:last_used="{row}">
        {{row.last_used ? $formatDate(row.last_used, FRIENDLY_DATE_FORMAT): $t('generic.na')}}
      </template>
    </data-table>
  </div>
</template>
<script>
  import Vue from 'vue'
  import VueClipboard from 'vue-clipboard2'
  import SimplePaymentTypeSelect from 'src/components/Autocomplete/SimplePaymentTypeSelect'
  import EditableGridCell from 'src/components/EditableGridCell'
  import entities from 'src/config/entities'
  import ClientTokensService from 'src/services/ClientTokensService'
  import config from 'src/config'
  import { FRIENDLY_DATE_FORMAT } from 'src/config/dateUtils'
  const { API_HOST, API_PORT } = config;
  Vue.use(VueClipboard)

  export default {
    name: 'client-management-tokens',
    components: {
      EditableGridCell,
      SimplePaymentTypeSelect
    },
    data () {
      return {
        FRIENDLY_DATE_FORMAT,
        ClientTokensService,
        entity: entities.JOB,
        multiPosterLink: `${API_HOST}:${API_PORT}/api/mp/v1`
      }
    },
    computed: {
      columns () {
        return [
          {
            prop: 'name',
            label: this.$t('client.tokens.columns.name'),
            minWidth: '150px'
          },
          {
            prop: 'token',
            label: this.$t('client.tokens.columns.token'),
            minWidth: '250px'
          },
          {
            prop: 'active',
            label: this.$t('client.tokens.columns.active'),
            minWidth: '100px'
          },
          {
            prop: 'payment_type',
            label: this.$t('client.tokens.columns.payment_type'),
            minWidth: '140px'
          },
          {
            prop: 'last_used',
            label: this.$t('client.tokens.columns.last_used'),
            minWidth: '140px'
          }
        ]
      },
      filters() {
        return [
          {
            key: 'match[client_uuid]',
            value: this.$route.params.id
          }
        ]
      }
    },
    methods: {
      async copy (token) {
        await this.$copyText(token)
        this.$notify({
          type: 'success',
          message: this.$t('client.tokens.messages.copied')
        })
      },
      async onPaymentTypeChange(newId, row) {
        row.payment_type_id = newId;
        await ClientTokensService.update(row.id, row)
      },
      async updateRowStatus(row, active) {
        row.active = active;
        await ClientTokensService.update(row.id, row)
      },
      async updateRowName (evt, key, row) {
        let value = evt.target.value
        let id = row.id
        if (id) {
          let data = {
            ...row,
            [key]: value
          }
          await ClientTokensService.update(id, data)
          row[key] = value
        } else {
          row[key] = value
        }
      },
      async createToken () {
        let client_uuid = this.$route.params.id
        await ClientTokensService.create({
          client_uuid,
          name: 'Token',
          active: true
        })
        this.$refs.table.refresh()
      }
    }
  }
</script>
<style>
</style>
